import { useEffect } from 'react'
import { EventNames } from '../../../../types/misc.types'
import { trackEvent } from '../../../../utils/appBridge'
import BottomSheetContent from '../../BottomSheetContent'

export const AvailableBalanceBottomSheet = ({
  onDismiss,
  ScreenName,
  trackingFund
}: {
  onDismiss: () => void
  ScreenName: string
  trackingFund?: { fundIsin: string; fundName: string }
}) => {
  const heading = 'Available balance'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName,
        ...(trackingFund ?? {})
      }
    })
  }, [])

  return (
    <BottomSheetContent
      heading={heading}
      onDismiss={onDismiss}
      bottomSheetHeadingClassName='!font-[500]'
      bottomSheetBodyClassName='!px-0 !pb-4'
    >
      <div className='text-[14px] font-[400] text-[#6A6E6E] leading-[150%] px-5 pl-[22px]'>
        This is the maximum amount you can withdraw right now, as per the latest NAV.
        <br />
        <br />
        Pledged or locked-in units are excluded since they are not eligible for withdrawal.
      </div>
    </BottomSheetContent>
  )
}
